import Vue from 'vue'
import { createTreeStore } from '../tree-store'

export const TREE_CONTEXT_KEY = 'treeContext'

export function createTreeContext() {
  const TreeContext = Vue.extend({
    data() {
      return {
        labelField: 'label',
        keyField: 'id',
        childrenField: 'children',
        expandedKeys: [],
        treeStore: null,
        checkedKeys: [],
        indeterminateKeys: [],
        selectedKeys: [],
        checkStrategy: 'all',
        group: true,
      }
    },
    computed: {
      flattenedNodes() {
        if (!this.treeStore) return []
        return this.treeStore.getFlattenedNodes(this.expandedKeys)
      },
      checkedState() { // 完整的选择状态
        const { checkedKeys, treeStore } = this
        if (!treeStore) {
          return {
            checkedKeys: [],
            indeterminateKeys: []
          }
        }
        const res = treeStore.getCheckedKeys(checkedKeys, [])
        return res
      }
    },
    methods: {
      init(vm) {
        this.treeInstance = vm
        this.labelField = vm.labelField
        this.keyField = vm.keyField
        this.childrenField = vm.childrenField
        this.checkStrategy = vm.checkStrategy || 'all'
        this.group = vm.group
        this.treeStore = createTreeStore(vm.data, {
          keyField: vm.keyField,
          childrenField: vm.childrenField
        })
      },
      updateStore(data) {
        this.treeStore = createTreeStore(data, {
          keyField: this.keyField,
          childrenField: this.childrenField
        })
      },
      toggleExpand(node) {
        const { key } = node
        const index = this.expandedKeys.indexOf(key)

        if (index !== -1) {
          this.expandedKeys.splice(index, 1)
          return
        }

        const nodeToBeExpanded = this.treeStore && this.treeStore.getNode(key)
        if (!nodeToBeExpanded || nodeToBeExpanded.isLeaf) {
          return
        }

        this.expandedKeys.push(key)
      },
      handleCheck(node, checked) {
        const checkedAction = checked ? 'check' : 'uncheck'
        const { treeStore, checkedState: {checkedKeys, indeterminateKeys} } = this
        const { checkedKeys: newCheckedKeys, indeterminateKeys: newIndeterminateKeys } = treeStore[checkedAction](
          [node.key],
          checkedKeys,
          indeterminateKeys,
          {
            cascade: true,
            checkStrategy: this.checkStrategy,
          })
        this.checkedKeys = newCheckedKeys
        this.indeterminateKeys = newIndeterminateKeys
        this.treeInstance.$emit('check', {
          node,
          checked,
          checkedKeys: newCheckedKeys,
          indeterminateKeys: newIndeterminateKeys
        })
      },
      handleSwitcherClick(node) {
        this.toggleExpand(node)
      },
      setCheckedKeys(keys) {
        this.checkedKeys = keys
      },
      handleSelect(node) {
        this.selectedKeys = [node.key]
      },
      // checkStrategy: 'all', 'parent', 'child'
      getCheckedKeys(checkStrategy = 'all') {
        if (checkStrategy === 'all') {
          return this.checkedState.checkedKeys
        }
        const { treeStore, checkedState: {checkedKeys, indeterminateKeys} } = this
        return treeStore.getCheckedKeys(checkedKeys, indeterminateKeys, {cascade: true, checkStrategy})
      },
      getCheckedNodes(checkStrategy = 'all') {
        const { treeStore, checkedState: {checkedKeys} } = this
        if (checkStrategy === 'all') {
          return checkedKeys.map(key => treeStore.getNode(key))
        }
        const keys = this.getCheckedKeys(checkStrategy).checkedKeys || []
        return keys.map(key => treeStore.getNode(key))
      }
    }
  })

  const context = new TreeContext()
  return context
}



// WEBPACK FOOTER //
// ./src/layout/components/tree/tree-context/create.js